
import React from "react";
import { Schemes } from "../../../../../../../utils";
import { i18nManager } from "../../../../../../../i18n";
import { Siren } from "../../../../../../shared/ConfirmDialog";
import { BaseService, IMember, ITournamentEdition, ITournamentEditionWebsite, SanitizedResponse, TournamentService } from "../../../../../../../services";
import { Button, Checkbox, Form, FormControl, TextAreaInput } from "@rivtn/noseur";
import { Elements } from "../../../../../../shared/Elements";

export interface DetailsProps {
    profile: IMember;
    tournamentEdition: ITournamentEdition;
    tournamentEditionWebsite: ITournamentEditionWebsite;
}

function Details(props: DetailsProps) {

    const { tournamentEdition } = props;
    const tournamentService = TournamentService.getInstance();
    const labels = i18nManager.Labels.host.manage_tournament.settings.about.details;
    const [tournamentEditionWebsite, setTournamentEditionWebsite] = React.useState<ITournamentEditionWebsite>(props.tournamentEditionWebsite);

    return (<Form scheme={Schemes.OMNEHOST} className="profile-settings team-settings" style={{ padding: 0, boxShadow: "none" }}>
        <FormControl isFieldset fill label={labels.tour_details} style={{ marginTop: 0, flex: 1 }} contentStyle={{ flex: 1 }}>
            <TextAreaInput style={{ height: "100%" }} defaultValue={tournamentEditionWebsite.details} fill onInputComplete={(details: string) => {
                setTournamentEditionWebsite({ ...tournamentEditionWebsite, details });
            }} />
        </FormControl>
        <Button scheme={Schemes.OMNEHOST} loadingProps={Elements.BUTTON_LOADING_PROPS} text={i18nManager.Labels.common.save_changes}
            style={{ marginTop: 30, padding: "10px 25px", }} onClick={(e) => {
                e.manageRef?.setLoadingState(true);
                tournamentService.updateTournamentEditionWebsite(tournamentEdition.external_id, tournamentEditionWebsite).then(({ }: SanitizedResponse<any>) => {
                    Siren.alert(labels.update_successful);
                }).catch(BaseService.reportError).finally(() => {
                    e.manageRef?.setLoadingState(false);
                });
            }} />
    </Form>);

}

export default Details;
